import { EnderecoWsCep } from './endereco-ws-cep.model';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class EnderecoWsCepService {

    constructor(private http: Http) {
    }

    getEnderecoWsCep(cep: string): Observable<EnderecoWsCep> {
        return this.http.get(`http://viacep.com.br/ws/${cep}/json/`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }

    getEnderecoWsCepLogradouro(logradouro: string, localidade: string, uf: string): Observable<EnderecoWsCep[]> {
        return this.http.get(`http://viacep.com.br/ws/${uf}/${localidade}/${logradouro}/json/`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }

}



// WEBPACK FOOTER //
// ./src/app/endereco-ws-cep/endereco-ws-cep.service.ts